
export default () => ({
	orders: null,
	ordersMeta: {},
	reservations: null,
	reservationsMeta: {},
	returningOrders: null,
	returningOrdersMeta: {},
	carts: null,
	cartsMeta: null,
	supplierOrders: null,
	supplierOrderProducts: null,
	supplierOrdersMeta: {},
	ordersProducts: null,
	ordersProductsColumns: {},
	ordersProductsOriginalColumns: [],
	ordersProductsMeta: {},
	returningOrdersProducts: null,
	returningOrdersProductsColumns: {},
	returningOrdersProductsOriginalColumns: [],
	returningOrdersProductsMeta: {},
	order: {},
	reservation: {},
	returningOrder: {},
	loading: {
		orders: false,
		reservations: false,
		statistics: false,
		trackingHistory: false,
		products: false
	},
	trackingHistory: [],
	products: [],
	productsBackup: [],
	productsMeta: {},
	reservationProducts: [],
	reservationProductsBackup: [],
	reservationProductsMeta: {},
	returningProducts: [],
	returningProductsBackup: [],
	returningProductsMeta: {},
	searchFilters: {},
	reservationsSearchFilters: {},
	supplierOrderSearchFilters: {},
	returnInformation: {},
	ordersProductsSortBy: null,
	ordersProductsSortOrder: 'desc',
	statistics: [],
	dimensions: [
		{
			length: null,
			width: null,
			height: null,
			weight: null,
			palletShipment: false
		}
	]
})
